var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.submenu.length > 0)?_c('PFlyout',{attrs:{"items":_vm.submenu,"position":"left"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var toggleShow = ref.toggleShow;
var shown = ref.shown;
return [_vm._t("default",null,{"toggleShow":toggleShow,"shown":shown})]}}],null,true)}):_c('div',[_vm._t("default",null,{"toggleShow":_vm.noop,"shown":false})],2)}
var staticRenderFns = []

export { render, staticRenderFns }